import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
  type Dispatch,
  type SetStateAction,
} from "react";

// Define the context type
type MobileNavContextType = [boolean, Dispatch<SetStateAction<boolean>>];

// Initialize the context with undefined
const Context = createContext<MobileNavContextType | undefined>(undefined);

// Custom hook with safety check
export const useMobileNavContext = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      "useMobileNavContext must be used within a MobileNavContext provider",
    );
  }
  return context;
};

// Props for the provider
interface MobileNavProviderProps {
  children: ReactNode;
}

export const MobileNavContext = ({ children }: MobileNavProviderProps) => {
  const [isMobileOpen, setIsMobileOpen] = useState<boolean>(false);

  return (
    <Context.Provider value={[isMobileOpen, setIsMobileOpen]}>
      {children}
    </Context.Provider>
  );
};
